import { createElement, isValidElement, type ComponentType } from 'react';
import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import Badge from '@material-ui/core/Badge';
import DnsIcon from '@material-ui/icons/Dns';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/Notifications';
import SearchIcon from '@material-ui/icons/Search';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';

const Pm2SidebarIcon = () => <DnsIcon />;

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => {
        const icon = item.icon;
        const NavIcon = () => {
          if (isValidElement(icon)) {
            return icon;
          }
          if (icon) {
            return createElement(icon as unknown as ComponentType);
          }
          return null;
        };
        return <SidebarItem icon={NavIcon} to={item.href} text={item.title} />;
      });
      // Skipped items
      nav.take('page:search'); // Using search modal instead
      nav.take('page:pm2'); // Rendered explicitly in the main menu
      nav.take('page:app/pm2'); // Rendered explicitly in the main menu
      nav.take('page:notifications'); // Rendered explicitly as NotificationsSidebarItem below

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {nav.take('page:catalog')}
            <SidebarItem icon={Pm2SidebarIcon} to="/pm2" text="System" />
            <SidebarDivider />
            {nav.take('page:scaffolder')}
            {nav.take('page:api-docs')}
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <NotificationsSidebarItem
            renderItem={({ unreadCount, to, onClick }) => (
              <SidebarItem
                to={to}
                onClick={onClick}
                text="Notifications"
                icon={() => (
                  <Badge
                    badgeContent={unreadCount}
                    color="error"
                    overlap="circular"
                    max={99}
                  >
                    <NotificationsIcon />
                  </Badge>
                )}
              />
            )}
          />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
